import React from 'react';
import { toast } from 'sonner';
import { Button } from '../../ui/button';
import { adminAPI } from '../../../lib/api';
import { ChecksList, TotalsTable } from './ResetTables';

const download = async (tenantId, resetId, kind) => {
  try {
    const res = await adminAPI.reservationResetFile(tenantId, resetId, kind);
    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = `reservation_reset_${kind}_${resetId}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  } catch {
    toast.error('Download failed');
  }
};

const tone = (r) => (!r.checks ? 'border-slate-300 bg-slate-50' : r.all_checks_passed ? 'border-emerald-300 bg-emerald-50/50' : 'border-red-300 bg-red-50/50');
const summary = (r) => (!r.checks ? 'Reset recorded. Loading the checks from the moment it ran…'
  : r.all_checks_passed ? 'Reset complete. All checks passed.' : 'Reset recorded, but some checks failed. Review below.');

export const ResultPanel = ({ tenantId, result, onVerify, verifying }) => (
  <div className="space-y-5" data-testid="reset-result-panel">
    <div className={`rounded-lg border-2 p-4 ${tone(result)}`}>
      <p className="font-semibold" data-testid="reset-result-summary">{summary(result)}</p>
      <p className="text-sm text-muted-foreground" data-testid="reset-result-id">Reset ID {result.reset_id} · {result.reset_at}</p>
    </div>
    {result.before && <TotalsTable before={result.before} after={result.after} />}
    {result.checks && <><h2 className="text-base font-semibold">Checks at the moment of the reset</h2><ChecksList checks={result.checks} /></>}
    {result.current_checks && (
      <div className="space-y-2" data-testid="reset-current-checks">
        <h2 className="text-base font-semibold">Same checks against today's data</h2>
        <p className="text-sm text-muted-foreground" data-testid="reset-current-note">
          {result.current_all_match ? 'Nothing has changed since the reset.'
            : 'Some values differ from the moment of the reset. This is expected once normal work (new requests, allocations) has happened since.'}
        </p>
        <ChecksList checks={result.current_checks} prefix="current" />
      </div>
    )}
    <div className="flex flex-wrap gap-2">
      <Button onClick={() => download(tenantId, result.reset_id, 'report')} data-testid="reset-download-report">Download before/after report</Button>
      <Button variant="outline" onClick={() => download(tenantId, result.reset_id, 'audit')} data-testid="reset-download-audit">Download audit records</Button>
      <Button variant="outline" disabled={verifying} onClick={onVerify} data-testid="reset-verify-button">
        {verifying ? 'Checking…' : 'Compare with current data'}
      </Button>
    </div>
  </div>
);
